import $ from 'jquery';
import errorResponseHandler from './errorResponseHandler';

function AnonymousRepositoryHelper() {

  var self = this;

  /**
   * Returns a promise for an anonymous GET AJAX request
   * @param {string} url
   * @return {Promise}
   */
  self.ajaxGet = function (url) {
    return new Promise(function (resolve, reject) {
      $.ajax(createAjaxSetting(url)).then(resolve, function (jqXhr) {
        errorResponseHandler.handleErrorResponse(jqXhr);
        reject(jqXhr);
      });
    });
  };

  /**
   * Returns a promise for an anonymous POST AJAX request. Post should be used to create a new resource
   * @param {string} url
   * @param {*} data JavaScript object
   * @return {Promise}
   */
  self.ajaxPost = function (url, data) {

    return new Promise(function (resolve, reject) {
      $.ajax(createAjaxSetting(url, 'POST', data)).then(resolve, function (jqXhr) {
        errorResponseHandler.handleErrorResponse(jqXhr);
        reject(jqXhr);
      });
    });
  };

  /**
   * Returns a promise for a Delete AJAX request.
   * @param {string} url
   * @return {Promise}
   */
  self.ajaxDelete = function (url) {
    return new Promise(function (resolve, reject) {
      $.ajax(createAjaxSetting(url, 'DELETE')).then(resolve, function (jqXhr) {
        errorResponseHandler.handleErrorResponse(jqXhr);
        reject(jqXhr);
      });
    });
  };

  /**
   * Returns a promise for a PUT AJAX request. Put should be used to update a resource that already exists
   * @param {string} url
   * @param {*} data JavaScript object
   * @return {Promise}
   */
  self.ajaxPut = function (url, data) {
    return new Promise(function (resolve, reject) {
      $.ajax(createAjaxSetting(url, 'PUT', data)).then(resolve, function (jqXhr) {
        errorResponseHandler.handleErrorResponse(jqXhr);
        reject(jqXhr);
      });
    });
  };

  /**
   * Creates an jQuery AJAX setting object for the given parameters to execute an anonymous request
   * @param {string} url
   * @param {string} [type]
   * @param {*} [data]
   * @return {*}
   */
  function createAjaxSetting(url, type, data) {

    var settings = {
      url: url,
      type: type || 'GET',
      dataType: type === 'DELETE' ? null : 'json' // Alway expect a JSON response unless deleting
    };

    if (data) {
      settings.data = JSON.stringify(data);
      settings.contentType = 'application/json';
    }

    return settings;
  }
}

export default new AnonymousRepositoryHelper();
